//@ts-expect-error FormattedDuration does not have a TS implementation.
import FormattedDuration from 'I18n/components/FormattedDuration';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { BREACHED_PROPERTY_VALUE, CLOSE_TICKET_SLA } from 'conversations-internal-schema/sla/constants/enums';
import { getIsDueInLessThanEightHours, getIsDueTomorrow, isDueToday } from 'conversations-internal-schema/sla/operators/dueDateComparators';
import { useCurrentTime } from '../../../_internal/hooks/useCurrentTime';
import { jsx as _jsx } from "react/jsx-runtime";
export const SLADueDate = ({
  slaCategory,
  dueDate,
  slaStatus
}) => {
  const {
    currentTime
  } = useCurrentTime();
  const dueDateObject = new Date(dueDate);
  const verbComponent = slaCategory === CLOSE_TICKET_SLA ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.SLAVerbs.timeToClose"
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.SLAVerbs.timeToFirstResponse"
  });
  if (slaStatus === BREACHED_PROPERTY_VALUE) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.dueDateBreached",
      options: {
        verb: verbComponent
      }
    });
  }
  if (getIsDueInLessThanEightHours(dueDate, currentTime)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.dueWithinDuration",
      options: {
        verb: verbComponent,
        duration: /*#__PURE__*/_jsx(FormattedDuration, {
          to: dueDate,
          includeAffix: true
        })
      }
    });
  }
  if (getIsDueTomorrow(currentTime, dueDateObject)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.dueByTommorow",
      options: {
        verb: verbComponent,
        time: /*#__PURE__*/_jsx(FormattedDateTime, {
          value: dueDate,
          format: "LT",
          type: "userTz"
        })
      }
    });
  }
  const dueDateStringFormat = isDueToday(currentTime, dueDateObject) ? 'LT' : 'short-date';
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "svh-onboarding-config-shared-lib.sla.detailsTooltip.dueBySpecificTime",
    options: {
      verb: verbComponent,
      timeOrDate: /*#__PURE__*/_jsx(FormattedDateTime, {
        value: dueDate,
        format: dueDateStringFormat,
        type: "userTz"
      })
    }
  });
};
SLADueDate.displayName = 'SLADueDate';